import React from 'react';
import classnames from 'classnames';
import * as styles from './GlobalNav.module.styl';
import SubMenuItem from './SubMenuItem';
import IntegrationItem from './IntegrationItem';
import FeaturedItem from './FeaturedItem';

const SubMenu = ({
  isOpen = false,
  title = '',
  subMenu = null,
  integrations = null,
  helpMenu = null,
  featuredItem = {},
}) => {
  if (!(subMenu || integrations)) return null;

  return (
    <div
      className={classnames(styles.subMenu, isOpen ? styles.subMenuOpen : null)}
    >
      <div className={styles.subMenuContainer}>
        {subMenu?.length > 0 ? (
          <div className={styles.subMenuItems}>
            {title ? <h3 className={styles.subMenuTitle}>{title}</h3> : null}
            <div
              className={classnames(
                styles.subMenuItemGrid,
                subMenu.length > 4 ? styles.manyItems : null,
              )}
            >
              {subMenu.map((subItem, i) => (
                <SubMenuItem key={i} subItem={subItem} />
              ))}
            </div>
          </div>
        ) : null}
        {integrations?.length > 0 ? (
          <div className={styles.subMenuItems}>
            {title ? <h3 className={styles.subMenuTitle}>{title}</h3> : null}
            <div
              className={classnames(
                styles.subMenuItemGrid,
                integrations.length > 4 ? styles.manyItems : null,
              )}
            >
              {integrations.map((integration, i) => (
                <IntegrationItem key={i} integration={integration} />
              ))}
            </div>
          </div>
        ) : null}
        <FeaturedItem featuredItem={featuredItem} />
        {helpMenu?.length > 0 ? (
          <div className={styles.helpMenuItems}>
            <h3 className={styles.subMenuTitle}>Need Help?</h3>
            <div className={styles.helpMenuItemGrid}>
              {helpMenu.map((helpItem, i) => (
                <SubMenuItem key={i} subItem={helpItem} />
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SubMenu;
